import Api from './api';
import SRRData from '../data/surveuResult-recommendation.json';
import { isType } from 'aws-sdk/lib/util';

export function isValidEmail(str) {
  return /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    str
  );
}

export function isMobile(userAgent) {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    userAgent
  );
}

export function isMacMobile(userAgent) {
  var u = navigator.userAgent, app = navigator.appVersion;
  if(/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))){
   if(window.location.href.indexOf("?mobile")<0){
    try{
     if(/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)){
      return true;
     }else{
      return false;
     }
    }catch(e){}
   }
  }else if( u.indexOf('iPad') > -1){
      return true;
  }else{
      return false;
  }
}

export function isValidPhone(str) {
  return /[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/.test(str);
}

export function isJSON(str) {
  if (typeof str == 'string') {
      try {
          var obj=JSON.parse(str);
          if(typeof obj == 'object' && obj ){
              return true;
          }else{
              return false;
          }
      } catch(e) {
          console.log('error：'+str+'!!!'+e);
          return false;
      }
  }
  console.log('It is not a string!')
}

export function capitalize(str) {
  if (!str) return '';
  if (str === "spf") return "SPF";
  return str.replace(/\b\w/g, l => l.toUpperCase());
}

export function camelize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

export function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function convertToStandardTime(timestamp) {
  let d = new Date(timestamp * 1000), // Convert the passed timestamp to milliseconds
    yyyy = d.getFullYear(),
    mm = ("0" + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
    dd = ("0" + d.getDate()).slice(-2), // Add leading 0.
    hh = d.getHours(),
    h = hh,
    min = ("0" + d.getMinutes()).slice(-2), // Add leading 0.
    ampm = "AM",
    time;

  if (hh > 12) {
    h = hh - 12;
    ampm = "PM";
  } else if (hh === 12) {
    h = 12;
    ampm = "PM";
  } else if (hh === 0) {
    h = 12;
  }

  // ie: 2013-02-18, 8:35 AM
  time = yyyy + "-" + mm + "-" + dd + ", " + h + ":" + min + " " + ampm;

  return time;
}

export function renderTimestamp() {
  Date.prototype.toIsoString = () => {
    let tzo = -this.getTimezoneOffset(),
      dif = tzo >= 0 ? "+" : "-",
      pad = num => {
        var norm = Math.floor(Math.abs(num));
        return (norm < 10 ? "0" : "") + norm;
      };
    return (
      this.getFullYear() +
      "-" +
      pad(this.getMonth() + 1) +
      "-" +
      pad(this.getDate()) +
      "T" +
      pad(this.getHours()) +
      ":" +
      pad(this.getMinutes()) +
      ":" +
      pad(this.getSeconds()) +
      dif +
      pad(tzo / 60) +
      ":" +
      pad(tzo % 60)
    );
  };

  let dt = new Date();
  return dt;
}

export function getTodayDate() {
    var today = new Date();
    var n = today.getDate();
    var m = today.getMonth();
    var y = today.getFullYear();
    if(m >= 9){
       m = '0'+m;
    }
    return (m*1+1)+'.'+n+'.'+y;
}

export function animateScroll(element,speed) {
  let rect=element.getBoundingClientRect();
  //获取元素相对窗口的top值，此处应加上窗口本身的偏移
  let top=window.pageYOffset+rect.top;
  let currentTop=0;
  let requestId;
  //采用requestAnimationFrame，平滑动画
  function step(timestamp) {
    currentTop+=speed;
    if(currentTop<=top){
      window.scrollTo(0,currentTop);
      requestId=window.requestAnimationFrame(step);
    }else{
      window.cancelAnimationFrame(requestId);
    }
  }
  window.requestAnimationFrame(step);
}


export function setCookie(cname, cvalue, exdays){
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++)
  {
    var c = ca[i];
    while (c.charAt(0) == ' ')
    {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// 根据区号代码获取各国区号number
export function getCountry(countryCode){
  var countryNumber;
  switch (countryCode){
    case 'US':
      countryNumber = 1;
    break;

    case 'Canada':
      countryNumber = 1;
    break;

    case 'UK':
      countryNumber = 44;
    break;
    default:
    countryNumber = 1;
  }
  return countryNumber;
}

export function transformationCountryNumberId(countryCode){
  var countryNumber;
  switch (countryCode){
    case 'US':
      countryNumber = 1;
    break;

    case 'Canada':
      countryNumber = 2;
    break;

    case 'UK':
      countryNumber = 3;
    break;

    default:
    countryNumber = 1;
  }
  return countryNumber;
}

export function transformationCountryNumber(countryCode){
  var countryNumber;
  countryCode = parseInt(countryCode);
  switch (countryCode){
    case 1:
      countryNumber = "US";
    break;

    case 2:
      countryNumber = "Canada";
    break;

    case 3:
      countryNumber = "UK";
    break;
    default:
    countryNumber = "US";
  }
  return countryNumber;
}


//防抖
// 设置一个定时器，设置在规定的时间后触发事件处理，每次触发时间都会重置计时器
//用处：用于搜索框和滚动的箭筒事件处理
export function debounce(fn,delay = 500){
  let timer = null;
  return function () {
    if(timer){
        clearTimeout(timer)
    }
    timer = setTimeout(()=>{
      fn.apply(this, arguments)
      timer = null
    },delay)
  }
}

//节流
// 定义每隔一定时间才能执行一次
// 设置一个定时器，设置0.5秒后执行事件，如果时间到了，就会执行函数并重置定时器，等待下一个0.5秒后再执行
export function throttle(fn,delay = 500){
  let timer = null;
  return function () {
    if(timer){
      return 
    }
    timer = setTimeout(()=>{
      fn.apply(this, arguments)
      timer = null
    },delay)
  }
}

export function not_logged_DiscountCodeLog_decide(discountCode,isSet) {
  if(!discountCode) return false
  let discountCodeLog = localStorage.getItem("not_logged_DiscountCodeLog");

  let discountCodeLogJson = [];

  try {
    discountCodeLogJson = discountCodeLog.split(",");
  } catch (error) {
    discountCodeLogJson = []
  }

  if(discountCodeLogJson.includes(discountCode)){
    return true;
  }else{
    if(isSet == true){
      discountCodeLogJson.push(discountCode);
      localStorage.setItem("not_logged_DiscountCodeLog",discountCodeLogJson);
    }
    return false;
  }
}

// 购物完成取到 thankYou 页面
export function fun_payEndgotoShowThankYou (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue) {
  for (let key in localStorage) {
      if (key.includes("order-")) localStorage.removeItem(key);
  }
  localStorage.removeItem('cart-products-ids');
  this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue }});
}

// 数组合并去重复
export function MergeArray(arr1,arr2){
  var _arr = new Array();
  for(var i=0;i<arr1.length;i++){
     _arr.push(arr1[i]);
  }
  for(var i=0;i<arr2.length;i++){
      var flag = true;
      for(var j=0;j<arr1.length;j++){
          if(arr2[i]==arr1[j]){
              flag=false;
              break;
          }
      }
      if(flag){
          _arr.push(arr2[i]);
      }
  }
  return _arr;
}

// 购物车商品合并去重复
export function cardGoodMergeArray(arr1,arr2){
  var _arr = new Array();
  for(var i=0;i<arr1.length;i++){
     _arr.push(arr1[i]);
  }
  try {
    for(var i=0;i<arr2.length;i++){
      var flag = true;
      for(var j=0;j<arr1.length;j++){

          if(arr2[i]['id'] == arr1[j]['id']  ){
              flag=false;
              break;
          }

      }
      if(flag){
          _arr.push(arr2[i]);
      }
  }
  } catch (error) {
    console.log(error);
  }
  return _arr;
}

// 是否去测试问卷的按钮逻辑管理 
export function buttonsContentManage(type){
  let user_has_skin_profile = localStorage.getItem("user_has_skin_profile");  // 是否做完了问卷
  let auth_token = localStorage.getItem("auth_token");  // 是否登录
  let gateFeePaid = localStorage.getItem("gateFeePaid");  // 是否付费
  
  let visited_scheduleConsult = localStorage.getItem("visited_scheduleConsult")  // 是否安排了 计划咨询
  var  url_visited_recommendations = localStorage.getItem("url_visited_recommendations");  // 是否手动输入的/recommendations
  var visitedRecommendations = localStorage.getItem("visited_recommendations");  // 是否去过了推荐产品页面

  let returnUrl =  '';
  let returnButtonText =  '';
  if(auth_token){
    if(!user_has_skin_profile){
      returnUrl = '/onboarding';
      returnButtonText = "Continue My Journey";

    }else if( user_has_skin_profile == "true" && gateFeePaid == "false" ){
      returnUrl = '/recommendation-landing';
      returnButtonText = "Continue My Journey";

    }else if(gateFeePaid == 'true'  && url_visited_recommendations != "true" ){
      if(visitedRecommendations == "true"){
        returnUrl = "/recommendations";
        returnButtonText = "My Recommendations";
      }else{
        returnUrl = "/recommendation-landing-thank";
        returnButtonText = "My Skin";
      }
    }

    // if(type == "recommendations_button" && user_has_skin_profile ){
    //   if(type == "recommendations_button" && gateFeePaid == 'true' ){
    //     returnUrl = "/recommendation-landing-thank";
    //   }else if(type == "recommendations_button" && gateFeePaid == 'false'){
    //     returnUrl = '/recommendation-landing';
    //   }
    // }else
    
    if(type == "login" && url_visited_recommendations == "true"){
      if(gateFeePaid == "true"){
        returnUrl = "/recommendations";
        returnButtonText = "My Recommendations";
      }else{
        returnUrl = "/survey-result"
        returnButtonText = "My Skin";
      }
    }
  }else{
    returnUrl = '/startonboarding';
    returnButtonText = "Learn More";
  }


  if(type == "buttonText"){
    return returnButtonText
  }else{
    return returnUrl;
  }
}



// export function recommendationsLogicManage(type){
//   var planTier = localStorage.getItem("planTier");
//   var visitedRecommendations = localStorage.getItem("visited_recommendations");
//   var gateFeePaid = localStorage.getItem("gateFeePaid");
//   var  url_visited_recommendations = localStorage.getItem("url_visited_recommendations");  // 是否手动输入的/recommendations
  
//   var returnUrl = "My Recommendations";
  
//   if(planTier == "1" || visitedRecommendations == "true"){
//     returnUrl = "/recommendations";
//   }else if((gateFeePaid == "false" && planTier != "1")  || planTier == null || planTier == 'null' ){
//     returnUrl = "/plan";
//   } else if(gateFeePaid == 'true' && visitedRecommendations == "false" && url_visited_recommendations != "true" ){
//     returnUrl = "/recommendation-landing";
//   }else{
//     if(type == "login" && url_visited_recommendations == "true"){
//       if(gateFeePaid == "true"){
//         returnUrl = "/recommendations";
//       }else{
//         returnUrl = "/survey-result";
//       }
//     }else{
//       returnUrl = "/recommendation-landing"
//     }
//   }
//   return returnUrl;
// }

export function recommendationsProductTypeInfo(type1,type2){

  var data ={
    dry:{
      description:'The core for taking care of  dry skin is locking moisture into your skin and protecting your skin’s natural moisture barrier.',
      cleanser:'As your skin appears to be dry, we suggest using a gel or milky cleanser that does not strip your skin from any oils naturally produced.You will feel refreshed, without the sensation of post wash tightness.',
      toner:'Toners balance your skin’s pH, ensure lightweight hydration, and reduce the appearance of pores, prepping your skin for the rest of your regimen.',
      moisturizer:'These recommended rich moisturizers will promote deep hydration and strengthen your skin barrier without heavy texture that may clog your pores.',
      spf:'Apply sunscreen, whether you are inside or out. UV rays damage the skin’s protective barrier and cause wrinkles, dark spots, and can even increase the likelihood of cancer.',
      'make-upremover':'Makeup removers are used to breakdown and remove all the makeup and sunscreen trapped in your pores. Followed by your daily cleanser to prepare your skin to absorb the hydrating products that fight the dryness.',
      serum:'Nutrient-rich serums are highly concentrated with active substances that contain a smaller molecule size than other skincare products including moisturizers. This smaller molecule size enables serums to penetrate your skin deeper and really target concerns and boost the effects of your daily skincare products.',
      exfoliator:'Exfoliators should be used 1-2x a week on clean skin to achieve optimal results. The right exfoliant will eliminate dry skin, unclog pores, smooth texture, address breakouts to give your skin a beautiful glow.',
      treatment:'Treatments are used to target your specific skin concerns and should be used as directed by your Esthetician.',
      mask:'Masks contain active ingredients that target specific concerns such as dryness, excess oils, blackheads, brightening and texture. ',
      eyecream:'The area under your eyes is very delicate and can be easily damaged. Eye creams improve hydration and help reduce dark circles, puffiness, and prevent wrinkles, contributing to a more youthful appearance.',
      supplement:'Beauty also comes from the inside. What we take into our bodies directly affects our skin health.',
      happinessguarantee:"We are confident in our selections for you. Try them, test them out, and if there's anything you don't love, send it back.",
      additionaloptions:'At Helloava, we believe that everything should start from a healthy skin. If you are constantly battling your skin concerns, let’s reboot your skin by having the right skincare staples! All you need is a gentle daily cleanser (and makeup remover if you are wearing any), a good moisturizer, and an SPF to keep a healthy and clear complexion.'
    },
    oily:{
      description:'The core for an oily skin baseline is to focus on the oil and hydration balance in your skin and to add ingredients that help control oil production in the skin.',
      cleanser:'Oily skin does not mean you need to go for a harsh cleanser. In contrast, over cleansing will cause overproduction of sebum.',
      toner:'Toners balance your skin’s pH, ensure lightweight hydration, and reduce the appearance of pores, prepping your skin for the rest of your regimen.',
      moisturizer:'We have selected these lightweight,  oil-free, and non-greasy moisturizers that  will nourish your skin and prevent the feeling of oiliness throughout the day.',
      spf:'Apply sunscreen, whether you are inside or out. UV rays damage the skin’s protective barrier and cause wrinkles, dark spots, and can even increase the likelihood of cancer.',
      'make-upremover':'Makeup removers are used to breakdown and remove all the makeup trapped in your pores. Followed by yourdaily cleanser to prepare your skin to absorb all the ingredients that fight acne and prevent the overproduction of oil.',
      serum:'Nutrient-rich serums are highly concentrated with active substances that contain a smaller molecule size than other skincare products including moisturizers. This smaller molecule size enables serums to penetrate your skin deeper and really target concerns and boost the effects of your daily skincare products.',
      exfoliator:'Exfoliators should be used 1-2x a week on clean skin to achieve optimal results. The right exfoliant will eliminate dry skin, unclog pores, smooth texture, address breakouts to give your skin a beautiful glow.',
      treatment:'Treatments are used to target your specific skin concerns and should be used as directed by your Esthetician.',
      mask:'Masks contain active ingredients that target specific concerns such as dryness, excess oils, blackheads, brightening and texture. ',
      eyecream:'The area under your eyes is very delicate and can be easily damaged. Eye creams improve hydration and help reduce dark circles, puffiness, and prevent wrinkles, contributing to a more youthful appearance.',
      supplement:'Beauty also comes from the inside. What we take into our bodies directly affects our skin health.',
      happinessguarantee:"We are confident in our selections for you. Try them, test them out, and if there's anything you don't love, send it back.",
      additionaloptions:'At Helloava, we believe that everything should start from a healthy skin. If you are constantly battling your skin concerns, let’s reboot your skin by having the right skincare staples! All you need is a gentle daily cleanser (and makeup remover if you are wearing any), a good moisturizer, and an SPF to keep a healthy and clear complexion.'
    },
    combination:{
      description:'The core for building a baseline for combination skin is to build and control the oil and hydration balance in your skin.',
      cleanser:'A gentle cleanser that will remove dirt and debris that can clog pores without over-stripping your skin',
      toner:'Toners balance your skin’s pH, ensure lightweight hydration, and reduce the appearance of pores, prepping your skin for the rest of your regimen.',
      moisturizer:'Keeping the skin hydrated with a lightweight moisturizer will ensure to lock in moisture without clogging your pores. ',
      spf:'Apply sunscreen, whether you are inside or out. UV rays damage the skin’s protective barrier and cause wrinkles, dark spots, and can even increase the likelihood of cancer.',
      'make-upremover':'Makeup removers are used to breakdown and remove any makeup that is trapped in your pores. Followed by your daily cleanser to prepare your skin to make the most of your personal routine.',
      serum:'Nutrient-rich serums are highly concentrated with active substances that contain a smaller molecule size than other skincare products including moisturizers. This smaller molecule size enables serums to penetrate your skin deeper and really target concerns and boost the effects of your daily skincare products.',
      exfoliator:'Exfoliators should be used 1-2x a week on clean skin to achieve optimal results. The right exfoliant will eliminate dry skin, unclog pores, smooth texture, address breakouts to give your skin a beautiful glow.',
      treatment:'Treatments are used to target your specific skin concerns and should be used as directed by your Esthetician.',
      mask:'Masks contain active ingredients that target specific concerns such as dryness, excess oils, blackheads, brightening and texture. ',
      eyecream:'The area under your eyes is very delicate and can be easily damaged. Eye creams improve hydration and help reduce dark circles, puffiness, and prevent wrinkles, contributing to a more youthful appearance.',
      supplement:'Beauty also comes from the inside. What we take into our bodies directly affects our skin health.',
      happinessguarantee:"We are confident in our selections for you. Try them, test them out, and if there's anything you don't love, send it back.",
      additionaloptions:'At Helloava, we believe that everything should start from a healthy skin. If you are constantly battling your skin concerns, let’s reboot your skin by having the right skincare staples! All you need is a gentle daily cleanser (and makeup remover if you are wearing any), a good moisturizer, and an SPF to keep a healthy and clear complexion.'
    }
  }
  var returnData = "";
  try {
    returnData = data[type1][type2];
  } catch (error) {
    returnData = "";
    console.error(error)
  }
  return returnData;
}


// key.replace("P","H");
// key.replace("N","L");
// key.replace("T","Y");
// key.replace("W","M");

export function surveryProctRecommendation(typeKey){
  var recoData = SRRData;
  try {
    return recoData[typeKey]
  } catch (error) {
    return []
  }

}

export function textToUpperCase(text){
  if(typeof(text) == 'string'){
    try {
      var oneText = text.substring(0,1);
      var allText = text.substring(text.length,1)
      var caseText =  oneText.toUpperCase();
      return caseText + allText;
    } catch (error) {
      return text;
    }
  }else{
    return text
  }
}

export function arrayRemoveObj(){
  if(!Array.prototype.remove){
    Array.prototype.remove = function(val) {
      var index = this.indexOf(val);
      if (index > -1) {
      this.splice(index, 1);
      }
    };
  }
}

export function getAge(birthDateString) {
  var today = new Date();
  var birthDate = new Date(birthDateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }
  return age;
}


// WEBPACK FOOTER //
// ./src/utils/util.js